import {createSelector} from 'reselect';
import {getPricingInfo, getPriceDetails} from './priceDetails';
import {isInBucket} from '../utils/abacusHelper';

const getBookingUrl = createSelector(
    [getPricingInfo, getPriceDetails],
    (pricingInfo, graphqlPriceDetails) => {
        const useGraphQl = isInBucket('ha_pdp_usePricingGraphQL');
        const bookingUrl = (useGraphQl ? graphqlPriceDetails : pricingInfo).checkoutUrl || null;

        return bookingUrl;
    }
);

export default getBookingUrl;
export {getBookingUrl};
